import { californiaHeaderLogo } from './California';
import { idahoHeaderLogo } from './Idaho';
import { minnesotaHeaderLogo } from './Minnesota';
import { nevadaHeaderLogo } from './Nevada';
import { newjersyHeaderLogo } from './NewJersy';
import { newmexicoHeaderLogo } from './NewMexico';
import { pennsylvaniaHeaderLogo } from './Pennsylvania';
import { georgiaHeaderLogo } from './Georgia';
import { virginiaHeaderLogo } from './Virginia';
import { getinsuredHeaderLogo } from './GetInsured';

export const headerLogoConfig = {
    'CA': californiaHeaderLogo,
    'ID': idahoHeaderLogo,
    'MN': minnesotaHeaderLogo,
    'NV': nevadaHeaderLogo,
    'NJ': newjersyHeaderLogo,
    'NM': newmexicoHeaderLogo,
    'PA': pennsylvaniaHeaderLogo,
    'GA': georgiaHeaderLogo,
    'VA': virginiaHeaderLogo,
    'GI': getinsuredHeaderLogo
};